import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';

const log = new Logger('TRANSACTION_REPORT_OSS', LOG_LEVELS.DEBUG);

export class ReportOSS extends Component {

    render() {
        log.debug('render(): ', this.props);

        if (!this.props.src) {
            return(
                <div><LanguageStringResolver string='transactionBlank_noData'/></div>
            )
        }
        var hiddenDivClass = this.props.isOSSUnion ? '' : 'invisible' ;
        return(
            <div data-test="oss-transaction-form">
                {this.props.src.map((item, index) => (
                    <table key={index} className="mb20" data-test="oss-transaction-table">
                        <thead>
                        <tr>
                            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_item'/></th>
                            <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_value'/></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_country'/></td>
                            <td>{item.country}</td>
                            <td><LanguageStringResolver string='transactionInvoice_mscon'/></td>
                            <td>{item.msCon}</td>
                        </tr>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_vatRateLetter'/></td>
                            <td>{item.vatRateLetter}</td>
                            <td><LanguageStringResolver string='transactionInvoice_vatRate'/></td>
                            <td><span><FormattedCurrencyValue value={item.vatRate}/></span></td>
                        </tr>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_msConCurrency'/></td>
                            <td>{item.msConCurrency}</td>
                            <td><LanguageStringResolver string='transactionInvoice_msConTaxB'/></td>
                            <td><span><FormattedCurrencyValue value={item.msConTaxB}/></span></td>
                        </tr>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_msConVAT'/></td>
                            <td><span><FormattedCurrencyValue value={item.msConVAT}/></span></td>
                            <td><LanguageStringResolver string='transactionInvoice_msidCurrency'/></td>
                            <td>{item.msIDCurrency}</td>
                        </tr>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_msidTaxB'/></td>
                            <td><span><FormattedCurrencyValue value={item.msIDTaxB}/></span></td>
                            <td><LanguageStringResolver string='transactionInvoice_msidvat'/></td>
                            <td><span><FormattedCurrencyValue value={item.msIDVAT}/></span></td>
                        </tr>
                        <tr>
                            <td><LanguageStringResolver string='transactionInvoice_isCorrrection'/></td>
                            <td>{item.isCorrrection}</td>
                            <td><LanguageStringResolver string='transactionInvoice_correctionDate'/></td>
                            <td>{item.correctionDate}</td>
                        </tr>
                        <tr className={hiddenDivClass}>
                            <td><LanguageStringResolver string='transactionInvoice_msEst'/></td>
                            <td>{item.msEST}</td>
                            <td><LanguageStringResolver string='transactionInvoice_ItemType'/></td>
                            <td>{item.itemType}</td>
                        </tr>
                        <tr className={hiddenDivClass}>
                            <td><LanguageStringResolver string='transactionInvoice_msEstVN'/></td>
                            <td>{item.msESTVATNumber}</td>
                            <td><LanguageStringResolver string='transactionInvoice_InvoiceNumber'/></td>
                            <td>{item.invoiceNumber}</td>
                        </tr>
                        </tbody>
                    </table>
                ))}
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): state & starting props', state, props);
    return {};
}


function mapDispatchersToProps(dispatch) {
    return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(ReportOSS);
